import { FixedIcon } from "../../../atoms/icons/fixed";
import { ArmIcon } from "../../../atoms/icons/arm";
import { addTrailingZeroes } from "../../../util/addTrailingZeroes";
import React from "react";

export const QuoteComparison = ({ quote }) => {
  const { amortizationType, apr, rate, loanTerm, term } = quote;
  return (
    <div className="quote-tag">
      <div className="centered-flex-row bold gap-small">
        {amortizationType === "Fixed" ? (
          <>
            <FixedIcon fill="white" width="20px" height="20px" />
            {`${loanTerm}yr`}
          </>
        ) : (
          <>
            <ArmIcon fill="white" width="20px" height="20px" />
            {`${term}/6`}
          </>
        )}
      </div>
      <div className="quote-tag-apr-rate">
        <div className="small-font bold">{addTrailingZeroes(rate)}%</div>
        <div className="small-font bold">{addTrailingZeroes(apr)}%</div>
      </div>
    </div>
  );
};
